import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartCatalogItemWithPrice,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}sellers/sparePartCatalogs`;

export interface GetSparePartCatalogsQueryArgs {
  sparePartCatalogId: string;
}

export const getSparePartCatalogsRequest = (
  payload: GetSparePartCatalogsQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { sparePartCatalogIds: payload.sparePartCatalogId }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSparePartCatalogsQuery = async (
  payload: GetSparePartCatalogsQueryArgs,
): Promise<
  BackResponse<SparePartCatalogItemWithPrice[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<SparePartCatalogItemWithPrice[]>>(
      getSparePartCatalogsRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
